/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Adddeallink_Button4Inputs */

const en_coinvestments_editemail_adddeallink_button4 = /** @type {(inputs: Coinvestments_Editemail_Adddeallink_Button4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert deal link`)
};

/**
* | output |
* | --- |
* | "Insert deal link" |
*
* @param {Coinvestments_Editemail_Adddeallink_Button4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_adddeallink_button4 = /** @type {((inputs?: Coinvestments_Editemail_Adddeallink_Button4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Adddeallink_Button4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_adddeallink_button4(inputs)
});
export { coinvestments_editemail_adddeallink_button4 as "coInvestments_editEmail_addDealLink_button" }